import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    button: {
        width: "fit-content",
        fontSize: "0.875rem",
        lineHeight: "0.875rem",
        height: "2rem",
        padding: "0.5rem 0.75rem",
    },
    roundedButton: {
        borderRadius: "1rem",
        padding: `${rem(8)} ${rem(16)}`,
    },
    textLabel: {
        gap: rem(5),
        fontSize: rem(14),
        fontWeight: 500,
        fontFamily: theme.fontFamily,
        lineHeight: "initial",
        color: theme.colors.gray[7],
    },
    noRecipientsText: {
        fontSize: `${rem(12)}`,
        fontWeight: 400,
        color: theme.colors.gray[7],
        margin: 0,
    },
    stackWrapper: {
        gap: rem(8),
    },
}))
